export class TextInput {

	value!: string;
	isValid: boolean = true;

	constructor() {
	}
}